export default "__VITE_ASSET__DGsNJbGJ__"